import React, {useState} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import {length, map, path, pathOr, slice} from 'ramda';

import css from './SearchPage.css';
import {isScrollingDisabled} from '../../ducks/UI.duck';
import {addToCart} from '../../ducks/user.duck';
import {withViewport} from '../../util/contextHelpers';
import {IconCheckmark, NamedLink, PrimaryButton} from '../../components';
import {getListingsById} from '../../ducks/marketplaceData.duck';
import defaultListingImg from '../../assets/default-img-listing/default-img-listing.jpg';
import {isServer} from '../../util/sdkLoader';
import {MAX_WIDTH_MOBILE} from '../TopbarContainer/Topbar/Topbar';
import {useHistory, useLocation} from 'react-router-dom';
import {createResourceLocatorString} from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

const CartPreview = (props) => {
  const {addToCart, listingsCovers} = props;
  const [canShowAssuranceSection, setCanShowAssuranceSection] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const numberOfItems = length(addToCart);
  const isMobile = !isServer() && window.innerWidth <= MAX_WIDTH_MOBILE;
  const maxItemsShown = isMobile ? 3 : 4;
  const hasMoreThanMaxItemsToShow = maxItemsShown - numberOfItems < 0;
  const handleGoCart = (e) => {
    e.preventDefault();
    history.push(createResourceLocatorString('CartPage', routeConfiguration(), {}, {}, location.search));
  };
  const handleShowAssuranceSection = (e) => {
    if (canShowAssuranceSection) return handleGoCart(e);
    e.preventDefault();
    setCanShowAssuranceSection(true);
  };
  if (!numberOfItems) return null;

  return (
    <div>
      <div className={css.cartPreviewContainer}>
        <div className={css.cartPreview}
             onClick={numberOfItems > 1 ? handleGoCart : handleShowAssuranceSection}>
          <div className={css.listingsPreviewsContainer}>
            {map((listingCover) => (
              <div className={css.listingPreviewContainerSuccess}>
                <img
                  src={listingCover ?? defaultListingImg}
                  className={css.listingPreviewImage}
                />
                <IconCheckmark rootClassName={css.check} size={'small'}/>
              </div>
            ), slice(0, maxItemsShown, listingsCovers))}
            {!hasMoreThanMaxItemsToShow && map(() => (
              <div className={css.listingPreviewContainer}/>
            ), new Array(Math.abs(maxItemsShown - numberOfItems)))}
            {hasMoreThanMaxItemsToShow && (
              <div className={css.listingPreviewHasMoreContainer}>
                +{Math.abs(maxItemsShown - numberOfItems)}
              </div>
            )}
          </div>
          <div>
            <PrimaryButton>
              <FormattedMessage
                id={canShowAssuranceSection ? "CartPreview.continue2" : "Marketplace.continue"}/>
            </PrimaryButton>
          </div>
        </div>
      </div>
      {canShowAssuranceSection && (
        <div className={css.cartPreviewContainer}>
          <div className={css.cartPreviewAssurance}>
            <FormattedMessage id="CartPreview.Assurance"/>
            <span className={css.cartPreviewAssuranceDisclaimer}><FormattedMessage
              id="CartPreview.disclaimer"/></span>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {currentUser} = state.user;
  const addToCart = pathOr([], ['attributes', 'profile', 'publicData', 'addToCart'], currentUser);
  const listingsInCart = getListingsById(state, map(id => ({uuid: id}), addToCart));
  const listingsCovers = map((listing) => path(['images', 0, 'attributes', 'variants', 'landscape-crop', 'url'], listing), listingsInCart);

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    listingsCovers,
    addToCart,
  };
};

const mapDispatchToProps = dispatch => ({});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withViewport,
  injectIntl,
)(CartPreview);
